/**
 * We need to warn users to disable adblock
 *  and this is not because we greedy, it simply block ws endpoint
 * Implements an adblock checker
 * if adblock is present than show modal
 */
import { AdBlockDetectedWrapper } from 'adblock-detect-react';
import { useState } from 'react';
import './styles.scss';

const AdblockChecker = () => {
  const [isHidden, setHidden] = useState<boolean>(false);
  return (
    <AdBlockDetectedWrapper>
      <div
        className={
          isHidden ? 'adblock__component--hidden' : 'adblock__component'
        }
      >
        <div className='adblock__present__backdrop' />
        <div className='adblock__present'>
          <div
            className='adblock__present__exitButton'
            onClick={() => setHidden(true)}
          />
          <div className='adblock__present__left'>
            <div className='adblock__present__left__icon' />
          </div>
          <div className='adblock__present__right'>
            <div className='adblock__present__right__title'>
              Adblock enabled
            </div>
            <div className='adblock__present__right__description'>
              Adblock could be the cause of a displaying problem. <br /> Please
              pause adblock on this site or disable adblock and refresh to
              proceed to the destination page.
            </div>
            <div
              className='adblock__present__right__button'
              onClick={() => window.location.reload()}
            >
              Refresh
            </div>
          </div>
        </div>
      </div>
    </AdBlockDetectedWrapper>
  );
};

export default AdblockChecker;
